var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuditLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F4413D",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.2498 33.4164C35.4664 33.4164 34.8332 34.0511 34.8332 34.833V40.4998C34.8332 41.2803 34.1985 41.9163 33.4164 41.9163H29.1664V20.6665C29.1664 19.4567 28.3958 18.3758 27.2371 17.9735L26.8176 17.8331H33.4164C34.1985 17.8331 34.8332 18.4692 34.8332 19.25V23.4999C34.8332 24.2817 35.4664 24.9165 36.2498 24.9165C37.0332 24.9165 37.6664 24.2817 37.6664 23.4999V19.25C37.6664 16.9068 35.7595 15 33.4164 15H18.1875C18.1335 15 18.0884 15.0241 18.036 15.0311C17.9678 15.0254 17.9027 15 17.8334 15C16.2708 15 15 16.2705 15 17.8331V43.3329C15 44.5427 15.7707 45.6236 16.9294 46.0259L25.455 48.8679C25.744 48.9571 26.0314 48.9997 26.3333 48.9997C27.8959 48.9997 29.1664 47.7289 29.1664 46.1663V44.7497H33.4164C35.7595 44.7497 37.6664 42.8429 37.6664 40.4998V34.833C37.6664 34.0511 37.0332 33.4164 36.2498 33.4164Z",
    fill: "#F4413D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5846 28.165L42.9179 22.4984C42.5129 22.0933 41.9036 21.9713 41.3739 22.1908C40.8455 22.4105 40.4998 22.9275 40.4998 23.5V27.7499H34.8332C34.0511 27.7499 33.4164 28.3844 33.4164 29.1665C33.4164 29.9486 34.0511 30.5831 34.8332 30.5831H40.4998V34.833C40.4998 35.4055 40.8455 35.9225 41.3739 36.1422C41.9036 36.3616 42.5129 36.2397 42.9179 35.8348L48.5846 30.168C49.1385 29.6142 49.1385 28.7188 48.5846 28.165Z",
    fill: "#F4413D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditLog);
export default __webpack_public_path__ + "static/media/audit-log.aba7d29cc9e811d0f69920e41f3d368b.svg";
export { ForwardRef as ReactComponent };